import { isSafeUrl } from '@atlaskit/adf-schema/url';
export var validatorFnMap = {
  safeUrl: isSafeUrl
};